// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__366Kv","content":"RecentSearches_content__3pO82"};